<template>
  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Advertencia</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{ mensaje }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-general-off"  data-dismiss="modal"><i class="ti-close"></i> Cancelar</button>
          <button type="button" class="btn btn-primary btn-general" @click="method" data-dismiss="modal"><i class="ti-check"></i> Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    method: { type: Function },
    mensaje: String,
  },
}
</script>
